
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b94"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b94"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gRshD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fragment = module.exports.jsxDEV = module.exports.jsxs = module.exports.jsx = void 0;

var $g8iUW = parcelRequire("g8iUW");

var $1MFjU = parcelRequire("1MFjU");

var $41VLu = parcelRequire("41VLu");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $c467891a48e95e7f$var$jsx(type, _a, key) {
    var _b;
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $g8iUW.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === "function" && (0, $1MFjU.isHTMLElementClass)(type)) type = (0, $1MFjU.tagNameOf)(type);
    children = (_b = children instanceof Array ? children.flat(Infinity) : [
        children
    ]) === null || _b === void 0 ? void 0 : _b.map(function(node) {
        return node instanceof Object ? new $41VLu.VNode(node) : node === 0 || node ? new $41VLu.VNode({
            text: node.toString()
        }) : new $41VLu.VNode({
            text: ""
        });
    });
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === "string" ? new $41VLu.VNode($g8iUW.__assign($g8iUW.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($g8iUW.__assign($g8iUW.__assign({}, commonProps), props));
}
module.exports.jsx = $c467891a48e95e7f$var$jsx;
module.exports.jsxs = $c467891a48e95e7f$var$jsx;
module.exports.jsxDEV = $c467891a48e95e7f$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $c467891a48e95e7f$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $g8iUW.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $41VLu.VNode({
        key: key,
        ref: ref,
        is: is,
        props: props,
        style: style,
        children: children
    });
};
module.exports.Fragment = $c467891a48e95e7f$var$Fragment;

});
parcelRegister("g8iUW", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $bbec114f87dbfe2a$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $bbec114f87dbfe2a$export$3c9a16f847548506);
$parcel$export(module.exports, "__exportStar", () => $bbec114f87dbfe2a$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $bbec114f87dbfe2a$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $bbec114f87dbfe2a$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $bbec114f87dbfe2a$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $bbec114f87dbfe2a$var$extendStatics = function(d, b) {
    $bbec114f87dbfe2a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bbec114f87dbfe2a$var$extendStatics(d, b);
};
function $bbec114f87dbfe2a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bbec114f87dbfe2a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bbec114f87dbfe2a$export$18ce0697a983be9b = function() {
    $bbec114f87dbfe2a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbec114f87dbfe2a$export$18ce0697a983be9b.apply(this, arguments);
};
function $bbec114f87dbfe2a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bbec114f87dbfe2a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bbec114f87dbfe2a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bbec114f87dbfe2a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bbec114f87dbfe2a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bbec114f87dbfe2a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bbec114f87dbfe2a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bbec114f87dbfe2a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bbec114f87dbfe2a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bbec114f87dbfe2a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bbec114f87dbfe2a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bbec114f87dbfe2a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bbec114f87dbfe2a$export$45d3717a4c69092e(o, m, p);
}
function $bbec114f87dbfe2a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bbec114f87dbfe2a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bbec114f87dbfe2a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bbec114f87dbfe2a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bbec114f87dbfe2a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bbec114f87dbfe2a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bbec114f87dbfe2a$export$10c90e4f7922046c(v) {
    return this instanceof $bbec114f87dbfe2a$export$10c90e4f7922046c ? (this.v = v, this) : new $bbec114f87dbfe2a$export$10c90e4f7922046c(v);
}
function $bbec114f87dbfe2a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bbec114f87dbfe2a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bbec114f87dbfe2a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bbec114f87dbfe2a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bbec114f87dbfe2a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bbec114f87dbfe2a$export$19a8beecd37a4c45 === "function" ? $bbec114f87dbfe2a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bbec114f87dbfe2a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bbec114f87dbfe2a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bbec114f87dbfe2a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bbec114f87dbfe2a$export$45d3717a4c69092e(result, mod, k);
    }
    $bbec114f87dbfe2a$var$__setModuleDefault(result, mod);
    return result;
}
function $bbec114f87dbfe2a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bbec114f87dbfe2a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bbec114f87dbfe2a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bbec114f87dbfe2a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bbec114f87dbfe2a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bbec114f87dbfe2a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bbec114f87dbfe2a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bbec114f87dbfe2a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bbec114f87dbfe2a$export$2e2bcd8739ae039 = {
    __extends: $bbec114f87dbfe2a$export$a8ba968b8961cb8a,
    __assign: $bbec114f87dbfe2a$export$18ce0697a983be9b,
    __rest: $bbec114f87dbfe2a$export$3c9a16f847548506,
    __decorate: $bbec114f87dbfe2a$export$29e00dfd3077644b,
    __param: $bbec114f87dbfe2a$export$d5ad3fd78186038f,
    __metadata: $bbec114f87dbfe2a$export$f1db080c865becb9,
    __awaiter: $bbec114f87dbfe2a$export$1050f835b63b671e,
    __generator: $bbec114f87dbfe2a$export$67ebef60e6f28a6,
    __createBinding: $bbec114f87dbfe2a$export$45d3717a4c69092e,
    __exportStar: $bbec114f87dbfe2a$export$f33643c0debef087,
    __values: $bbec114f87dbfe2a$export$19a8beecd37a4c45,
    __read: $bbec114f87dbfe2a$export$8d051b38c9118094,
    __spread: $bbec114f87dbfe2a$export$afc72e2116322959,
    __spreadArrays: $bbec114f87dbfe2a$export$6388937ca91ccae8,
    __spreadArray: $bbec114f87dbfe2a$export$1216008129fb82ed,
    __await: $bbec114f87dbfe2a$export$10c90e4f7922046c,
    __asyncGenerator: $bbec114f87dbfe2a$export$e427f37a30a4de9b,
    __asyncDelegator: $bbec114f87dbfe2a$export$bbd80228419bb833,
    __asyncValues: $bbec114f87dbfe2a$export$e3b29a3d6162315f,
    __makeTemplateObject: $bbec114f87dbfe2a$export$4fb47efe1390b86f,
    __importStar: $bbec114f87dbfe2a$export$c21735bcef00d192,
    __importDefault: $bbec114f87dbfe2a$export$da59b14a69baef04,
    __classPrivateFieldGet: $bbec114f87dbfe2a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bbec114f87dbfe2a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bbec114f87dbfe2a$export$81fdc39f203e4e04,
    __addDisposableResource: $bbec114f87dbfe2a$export$88ac25d8e944e405,
    __disposeResources: $bbec114f87dbfe2a$export$8f076105dc360e92
};

});

parcelRegister("1MFjU", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $14ca536f88a616ab$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $14ca536f88a616ab$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $14ca536f88a616ab$export$86f54f62aa7a7514);
$parcel$export(module.exports, "DiffStatus", () => $14ca536f88a616ab$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $14ca536f88a616ab$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $14ca536f88a616ab$export$3f063810d7bf01bd);
$parcel$export(module.exports, "Second", () => $14ca536f88a616ab$export$c489aa6f7fd82b1a);
$parcel$export(module.exports, "parseJSON", () => $14ca536f88a616ab$export$27924e57e9afff7f);
$parcel$export(module.exports, "templateOf", () => $14ca536f88a616ab$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $14ca536f88a616ab$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $14ca536f88a616ab$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $14ca536f88a616ab$export$b8a1af58c024fefd);
$parcel$export(module.exports, "isDOMReadOnly", () => $14ca536f88a616ab$export$a2cf0d4bb6e06de4);
$parcel$export(module.exports, "stringifyDOM", () => $14ca536f88a616ab$export$b0709844452f8b6b);
$parcel$export(module.exports, "importCSS", () => $14ca536f88a616ab$export$7cd14c57bbb84350);
$parcel$export(module.exports, "formToJSON", () => $14ca536f88a616ab$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "delegate", () => $14ca536f88a616ab$export$10b1921597150314);
function $14ca536f88a616ab$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $14ca536f88a616ab$var$$9b05bcda60cc529c$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $14ca536f88a616ab$export$61cc6ed0f143570b;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $14ca536f88a616ab$export$dd1bc94b04021eeb;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $14ca536f88a616ab$export$a09f818797e212c4;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $14ca536f88a616ab$export$170f4e08cad8229d;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $14ca536f88a616ab$export$67a6ce548ae77071;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $14ca536f88a616ab$export$a48f0734ac7c2329;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $14ca536f88a616ab$export$3f34ca2fef821bbd;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $14ca536f88a616ab$export$86f54f62aa7a7514;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $14ca536f88a616ab$export$89912e019eef22aa;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $14ca536f88a616ab$export$1c8ba402144543e5;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $14ca536f88a616ab$export$2ddabb89308e1a22;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $14ca536f88a616ab$export$14527669107aa301;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $14ca536f88a616ab$export$3f063810d7bf01bd;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $14ca536f88a616ab$export$b5a4d6f439a5044d;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $14ca536f88a616ab$export$b119cc7e1840e59c;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $14ca536f88a616ab$export$7b85fd78dd236198;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $14ca536f88a616ab$export$697c3df919c0e61a;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $14ca536f88a616ab$export$e6b5ff3168b5942b;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $14ca536f88a616ab$export$1d012a0dff3dab06;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $14ca536f88a616ab$export$69a3209f1a06c04d;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $14ca536f88a616ab$export$dce9414bed0662c;
});
function $14ca536f88a616ab$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $14ca536f88a616ab$export$dd1bc94b04021eeb(value) {
    return $14ca536f88a616ab$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $14ca536f88a616ab$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $14ca536f88a616ab$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $14ca536f88a616ab$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $14ca536f88a616ab$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $14ca536f88a616ab$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $14ca536f88a616ab$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $14ca536f88a616ab$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $14ca536f88a616ab$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $14ca536f88a616ab$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($14ca536f88a616ab$export$2ddabb89308e1a22 || ($14ca536f88a616ab$export$2ddabb89308e1a22 = {}));
function $14ca536f88a616ab$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = $14ca536f88a616ab$export$2ddabb89308e1a22.Old;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += $14ca536f88a616ab$export$2ddabb89308e1a22.New;
    }
    return {
        map: map,
        group: $14ca536f88a616ab$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $14ca536f88a616ab$export$b5a4d6f439a5044d(data) {
    if ($14ca536f88a616ab$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $14ca536f88a616ab$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $14ca536f88a616ab$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($14ca536f88a616ab$export$61cc6ed0f143570b(data)) return [];
    if ($14ca536f88a616ab$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $14ca536f88a616ab$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $14ca536f88a616ab$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $14ca536f88a616ab$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $14ca536f88a616ab$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $14ca536f88a616ab$export$1d012a0dff3dab06(list, iteratee) {
    const group = $14ca536f88a616ab$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $14ca536f88a616ab$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $14ca536f88a616ab$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
var $14ca536f88a616ab$var$$6a9944941b4c1893$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "sum", function() {
    return $14ca536f88a616ab$export$8a63f25cc62965f1;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $14ca536f88a616ab$export$e1f36757ecda301d;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $14ca536f88a616ab$export$8e694e1eafd55acb;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $14ca536f88a616ab$export$57d7c52a66287430;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $14ca536f88a616ab$export$2b4693832ca3ce16;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $14ca536f88a616ab$export$5b784e078da1ce6;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $14ca536f88a616ab$export$17ec9c9f4f23588c;
});
function $14ca536f88a616ab$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $14ca536f88a616ab$export$e1f36757ecda301d(...data) {
    return $14ca536f88a616ab$export$8a63f25cc62965f1(...data) / data.length;
}
function $14ca536f88a616ab$export$8e694e1eafd55acb(data, sample = false) {
    const average = $14ca536f88a616ab$export$e1f36757ecda301d(...data);
    const summary = $14ca536f88a616ab$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $14ca536f88a616ab$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($14ca536f88a616ab$export$8e694e1eafd55acb(data, sample));
}
function $14ca536f88a616ab$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($14ca536f88a616ab$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $14ca536f88a616ab$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $14ca536f88a616ab$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $14ca536f88a616ab$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
var $14ca536f88a616ab$var$$f872d8bba1c0f79f$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $14ca536f88a616ab$export$c489aa6f7fd82b1a;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $14ca536f88a616ab$export$cbd942915f33be50;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $14ca536f88a616ab$export$9b886f8493244014;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $14ca536f88a616ab$export$e99cbb807a5bb10d;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $14ca536f88a616ab$export$7a9a31a911eb9a20;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $14ca536f88a616ab$export$fca4f8121099df57;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $14ca536f88a616ab$export$6ce2f08d515512;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $14ca536f88a616ab$export$951c8378cdfec6e6;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $14ca536f88a616ab$export$1a4097b876a13bf7;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $14ca536f88a616ab$export$506c8e8f8c8edda;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $14ca536f88a616ab$export$3ae94a2503e890a1;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $14ca536f88a616ab$export$62ad822b3a5fd9a0;
});
const $14ca536f88a616ab$export$c489aa6f7fd82b1a = 1000;
const $14ca536f88a616ab$export$cbd942915f33be50 = $14ca536f88a616ab$export$c489aa6f7fd82b1a * 60;
const $14ca536f88a616ab$export$9b886f8493244014 = $14ca536f88a616ab$export$cbd942915f33be50 * 15;
const $14ca536f88a616ab$export$e99cbb807a5bb10d = $14ca536f88a616ab$export$9b886f8493244014 * 4;
const $14ca536f88a616ab$export$7a9a31a911eb9a20 = $14ca536f88a616ab$export$e99cbb807a5bb10d * 24;
const $14ca536f88a616ab$export$fca4f8121099df57 = $14ca536f88a616ab$export$7a9a31a911eb9a20 * 7;
const $14ca536f88a616ab$export$6ce2f08d515512 = $14ca536f88a616ab$export$7a9a31a911eb9a20 * 365;
const $14ca536f88a616ab$export$951c8378cdfec6e6 = $14ca536f88a616ab$export$6ce2f08d515512 / 12;
const $14ca536f88a616ab$export$1a4097b876a13bf7 = $14ca536f88a616ab$export$951c8378cdfec6e6 * 3;
const $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$TimeUnit = new Map([
    [
        "s",
        $14ca536f88a616ab$export$c489aa6f7fd82b1a
    ],
    [
        "m",
        $14ca536f88a616ab$export$cbd942915f33be50
    ],
    [
        "H",
        $14ca536f88a616ab$export$e99cbb807a5bb10d
    ],
    [
        "D",
        $14ca536f88a616ab$export$7a9a31a911eb9a20
    ],
    [
        "W",
        $14ca536f88a616ab$export$fca4f8121099df57
    ],
    [
        "M",
        $14ca536f88a616ab$export$951c8378cdfec6e6
    ],
    [
        "Y",
        $14ca536f88a616ab$export$6ce2f08d515512
    ]
]);
function $14ca536f88a616ab$export$506c8e8f8c8edda(end, start = new Date(), map = $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$TimeUnit) {
    const distance = +new Date(end) - +new Date(start);
    for (const [unit, base] of [
        ...map
    ].reverse()){
        const rest = distance / base;
        if (Math.abs(rest) >= 1) return {
            distance: +rest.toFixed(0),
            unit: unit
        };
    }
    return {
        distance: distance,
        unit: "ms"
    };
}
function $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $14ca536f88a616ab$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $14ca536f88a616ab$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $14ca536f88a616ab$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $14ca536f88a616ab$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $14ca536f88a616ab$var$$ba0e5dc395660a7c$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $14ca536f88a616ab$export$27924e57e9afff7f;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $14ca536f88a616ab$export$7ea17d45ecdcf634;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $14ca536f88a616ab$export$bb8626e4916f587b;
});
function $14ca536f88a616ab$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || $14ca536f88a616ab$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $14ca536f88a616ab$export$7ea17d45ecdcf634(raw) {
    const parsed = $14ca536f88a616ab$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $14ca536f88a616ab$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $14ca536f88a616ab$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $14ca536f88a616ab$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($14ca536f88a616ab$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}
var $14ca536f88a616ab$var$$083124ac4b1a50a0$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $14ca536f88a616ab$export$71e6483fc2b024eb;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $14ca536f88a616ab$export$eb9b2aadbe449a20;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $14ca536f88a616ab$export$13397a83aa5915d6;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $14ca536f88a616ab$export$fd89523fba250fa4;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $14ca536f88a616ab$export$504fbde693c1771c;
});
function $14ca536f88a616ab$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $14ca536f88a616ab$export$eb9b2aadbe449a20(raw = window.location.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($14ca536f88a616ab$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $14ca536f88a616ab$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : $14ca536f88a616ab$export$b5a4d6f439a5044d(value) ? $14ca536f88a616ab$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
function $14ca536f88a616ab$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$14ca536f88a616ab$export$dd1bc94b04021eeb(value) && [
            key,
            $14ca536f88a616ab$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $14ca536f88a616ab$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $14ca536f88a616ab$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $14ca536f88a616ab$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $14ca536f88a616ab$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $14ca536f88a616ab$var$$50872bf213056663$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $14ca536f88a616ab$export$1b9ac4d3de3ffd2e;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$50872bf213056663$exports, "makeSHA", function() {
    return $14ca536f88a616ab$export$d51f3b55e8d1aa73;
});
const $14ca536f88a616ab$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $14ca536f88a616ab$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $14ca536f88a616ab$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) crypto1.subtle = crypto1["webkitSubtle"];
}
async function $14ca536f88a616ab$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
var $14ca536f88a616ab$var$$93a3089d2937b23f$exports = {};
var $14ca536f88a616ab$var$$3e0a089cc13f69ad$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $14ca536f88a616ab$export$2ee022bbbc550b25;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $14ca536f88a616ab$export$a549dd5cef7f8327;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $14ca536f88a616ab$export$8eece510bcb9c62c;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $14ca536f88a616ab$export$b8a1af58c024fefd;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $14ca536f88a616ab$export$a2cf0d4bb6e06de4;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $14ca536f88a616ab$export$d66b332881d9723f;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $14ca536f88a616ab$export$b0709844452f8b6b;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $14ca536f88a616ab$export$5118471ee5d5453b;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $14ca536f88a616ab$export$be4650432daa84fd;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $14ca536f88a616ab$export$578e38b4a3e0b255;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $14ca536f88a616ab$export$7cd14c57bbb84350;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $14ca536f88a616ab$export$5100419dfae0456d;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $14ca536f88a616ab$export$28d9d24a8cd0ffc2;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $14ca536f88a616ab$export$3f99968195accfaf;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $14ca536f88a616ab$export$eafdbaa868ea9975;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $14ca536f88a616ab$export$36a0c1ca2ae264fa;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $14ca536f88a616ab$export$86d7c59254d6a2c9;
});
const $14ca536f88a616ab$var$$3e0a089cc13f69ad$var$templateMap = {};
function $14ca536f88a616ab$export$2ee022bbbc550b25(tagName) {
    if ($14ca536f88a616ab$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $14ca536f88a616ab$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $14ca536f88a616ab$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $14ca536f88a616ab$export$a549dd5cef7f8327(tagName) {
    const node = $14ca536f88a616ab$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $14ca536f88a616ab$export$8eece510bcb9c62c(Class) {
    return $14ca536f88a616ab$export$170f4e08cad8229d(Class, HTMLElement);
}
const $14ca536f88a616ab$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $14ca536f88a616ab$export$b8a1af58c024fefd(Class) {
    const name = $14ca536f88a616ab$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $14ca536f88a616ab$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $14ca536f88a616ab$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $14ca536f88a616ab$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $14ca536f88a616ab$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $14ca536f88a616ab$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $14ca536f88a616ab$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($14ca536f88a616ab$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $14ca536f88a616ab$export$5118471ee5d5453b(node, type);
}
function $14ca536f88a616ab$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $14ca536f88a616ab$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $14ca536f88a616ab$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $14ca536f88a616ab$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $14ca536f88a616ab$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${$14ca536f88a616ab$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$14ca536f88a616ab$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $14ca536f88a616ab$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $14ca536f88a616ab$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $14ca536f88a616ab$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $14ca536f88a616ab$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $14ca536f88a616ab$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $14ca536f88a616ab$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { type: type, name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? $14ca536f88a616ab$export$7ea17d45ecdcf634(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$14ca536f88a616ab$export$7ea17d45ecdcf634(value));
                break;
            case "fieldset":
                parsedValue = $14ca536f88a616ab$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = $14ca536f88a616ab$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$14ca536f88a616ab$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $14ca536f88a616ab$var$$bb23e0c794fefbef$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $14ca536f88a616ab$export$e772c8ff12451969;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $14ca536f88a616ab$export$57207d71b8c929c8;
});
function $14ca536f88a616ab$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $14ca536f88a616ab$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $14ca536f88a616ab$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $14ca536f88a616ab$var$$19ed8aeb7905a045$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $14ca536f88a616ab$export$10b1921597150314;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $14ca536f88a616ab$export$3e2b244719956741;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $14ca536f88a616ab$export$1d1d2ed6b55cf67f;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $14ca536f88a616ab$export$2155c0b5a4b77fb8;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $14ca536f88a616ab$export$9d97473344489dfc;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $14ca536f88a616ab$export$d635d04af3887bbe;
});
function $14ca536f88a616ab$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $14ca536f88a616ab$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $14ca536f88a616ab$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $14ca536f88a616ab$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $14ca536f88a616ab$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $14ca536f88a616ab$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $14ca536f88a616ab$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $14ca536f88a616ab$var$$7a08303ce13c49c5$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $14ca536f88a616ab$export$1b88f6b6d432a52a;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $14ca536f88a616ab$export$b70f6380221b1350;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $14ca536f88a616ab$export$75d6cbe4503e149;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $14ca536f88a616ab$export$b2618d51188815c2;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $14ca536f88a616ab$export$490814474ddbb428;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $14ca536f88a616ab$export$3ea201dffb50dfef;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $14ca536f88a616ab$export$d1012c7198c6b460;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $14ca536f88a616ab$export$a35a418b7b17958e;
});
class $14ca536f88a616ab$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $14ca536f88a616ab$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $14ca536f88a616ab$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $14ca536f88a616ab$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $14ca536f88a616ab$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $14ca536f88a616ab$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $14ca536f88a616ab$export$75d6cbe4503e149(type, element)))
    ]);
}
function $14ca536f88a616ab$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $14ca536f88a616ab$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $14ca536f88a616ab$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $14ca536f88a616ab$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $14ca536f88a616ab$export$490814474ddbb428(element, className, display = "block") {
    return $14ca536f88a616ab$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $14ca536f88a616ab$export$3ea201dffb50dfef(element, className, display = "block") {
    return $14ca536f88a616ab$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $14ca536f88a616ab$export$d1012c7198c6b460(element, className, remove) {
    return $14ca536f88a616ab$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $14ca536f88a616ab$export$a35a418b7b17958e(element, className, remove) {
    return $14ca536f88a616ab$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $14ca536f88a616ab$var$$69bd9f0117925302$exports = {};
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$69bd9f0117925302$exports, "describe", function() {
    return $14ca536f88a616ab$export$cd5450f3a47e3789;
});
$14ca536f88a616ab$var$$parcel$export($14ca536f88a616ab$var$$69bd9f0117925302$exports, "it", function() {
    return $14ca536f88a616ab$export$3486a10f30cf1ee4;
});
async function $14ca536f88a616ab$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $14ca536f88a616ab$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await $14ca536f88a616ab$export$e772c8ff12451969(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});

parcelRegister("41VLu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = void 0;
var $2ef410527d29b609$var$VNode = /** @class */ function() {
    function VNode(meta) {
        Object.assign(this, meta);
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return;
        this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, ".")),
            is && '[is="'.concat(is, '"]')
        ].filter(Boolean).join("");
    }
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute("is")
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== "style" && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: "class",
        htmlFor: "for"
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}();
module.exports.VNode = $2ef410527d29b609$var$VNode;

});


parcelRegister("fHi4g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $g8iUW = parcelRequire("g8iUW");

var $1MFjU = parcelRequire("1MFjU");

var $41VLu = parcelRequire("41VLu");
var $b6d8e30d9a9a2320$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.treeCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || "") + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith("aria-") ? (0, $1MFjU.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $1MFjU.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $g8iUW.__values(group[$1MFjU.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $g8iUW.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $g8iUW.__values($g8iUW.__spreadArray($g8iUW.__spreadArray([], $g8iUW.__read(group[$1MFjU.DiffStatus.Same] || []), false), $g8iUW.__read(group[$1MFjU.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $g8iUW.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.createNode = function(vNode, reusedVNodes) {
        var _a, _b;
        if (vNode.text) return vNode.node = document.createTextNode(vNode.text);
        var reusedVNode = vNode.selector && ((_a = reusedVNodes === null || reusedVNodes === void 0 ? void 0 : reusedVNodes[vNode.selector]) === null || _a === void 0 ? void 0 : _a.shift());
        vNode.node = vNode.tagName ? (reusedVNode === null || reusedVNode === void 0 ? void 0 : reusedVNode.node) || document.createElement(vNode.tagName, {
            is: vNode.is
        }) : document.createDocumentFragment();
        var node = this.patch(reusedVNode || {
            tagName: vNode.tagName,
            node: vNode.node
        }, vNode).node;
        if (node) (_b = vNode.ref) === null || _b === void 0 || _b.call(vNode, node);
        return node;
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChildren = function(root, newNodes) {
        var e_3, _a;
        try {
            for(var _b = $g8iUW.__values($g8iUW.__spreadArray([], $g8iUW.__read(root.childNodes), false)), _c = _b.next(); !_c.done; _c = _b.next()){
                var oldNode = _c.value;
                var index = newNodes.indexOf(oldNode);
                if (index < 0) continue;
                else if (index === 0) {
                    newNodes.shift();
                    continue;
                }
                var beforeNodes = newNodes.slice(0, index);
                if (!beforeNodes[0]) continue;
                oldNode.before.apply(oldNode, $g8iUW.__spreadArray([], $g8iUW.__read(beforeNodes), false));
                newNodes = newNodes.slice(index + 1);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (newNodes[0]) root.append.apply(root, $g8iUW.__spreadArray([], $g8iUW.__read(newNodes), false));
    };
    DOMRenderer.prototype.updateChildren = function(node, oldList, newList) {
        var e_4, _a;
        var _this = this;
        var _b = (0, $1MFjU.diffKeys)(oldList.map(this.keyOf), newList.map(this.keyOf)), map = _b.map, group = _b.group;
        var deletingGroup = group[$1MFjU.DiffStatus.Old] && (0, $1MFjU.groupBy)(group[$1MFjU.DiffStatus.Old].map(function(_a) {
            var _b = $g8iUW.__read(_a, 1), key = _b[0];
            return _this.vNodeOf(oldList, key);
        }), function(_a) {
            var selector = _a.selector;
            return selector + "";
        });
        var newNodes = newList.map(function(vNode, index) {
            var key = _this.keyOf(vNode, index);
            if (map[key] !== $1MFjU.DiffStatus.Same) return _this.createNode(vNode, deletingGroup);
            var oldVNode = _this.vNodeOf(oldList, key);
            return vNode.text != null ? vNode.node = oldVNode.node : _this.patch(oldVNode, vNode).node;
        });
        for(var selector in deletingGroup)try {
            for(var _c = (e_4 = void 0, $g8iUW.__values(deletingGroup[selector])), _d = _c.next(); !_d.done; _d = _c.next()){
                var vNode = _d.value;
                this.deleteNode(vNode);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.commitChildren(node, newNodes);
    };
    DOMRenderer.prototype.patch = function(oldVNode, newVNode) {
        var _this = this;
        var tagName = oldVNode.tagName;
        var isXML = (0, $1MFjU.templateOf)(tagName) && (0, $1MFjU.elementTypeOf)(tagName) === "xml";
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $1MFjU.toHyphenCase)(key) : $41VLu.VNode.propsMap[key] || key);
        }, function(node, key, value) {
            // @ts-ignore
            if (isXML || key.includes("-") || (0, $1MFjU.isDOMReadOnly)(tagName, key)) node.setAttribute(key, value);
            else node[_this.propsKeyOf(key)] = value;
        });
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(node, key) {
            return node.removeProperty(key);
        });
        this.updateChildren(oldVNode.node, oldVNode.children || [], newVNode.children || []);
        newVNode.node = oldVNode.node;
        return newVNode;
    };
    DOMRenderer.prototype.render = function(vNode, node) {
        if (node === void 0) node = document.body;
        var root = this.treeCache.get(node) || $41VLu.VNode.fromDOM(node);
        root = this.patch(root, $g8iUW.__assign($g8iUW.__assign({}, root), {
            children: [
                vNode
            ]
        }));
        this.treeCache.set(node, root);
        return root;
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        var body = document.implementation.createHTMLDocument().body;
        this.render(tree, body);
        return body.innerHTML;
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $b6d8e30d9a9a2320$var$DOMRenderer;

});

parcelRegister("dDNcL", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved_;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("FLqxQ", function(module, exports) {

var $y4uGz = parcelRequire("y4uGz");
module.exports = $y4uGz("ktczW").then(()=>parcelRequire("80YIH"));

});
parcelRegister("y4uGz", function(module, exports) {
"use strict";

function $0666a97ddd483991$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5IkBo")).resolve(id));
}
module.exports = $0666a97ddd483991$var$load;

});



var $gRshD = parcelRequire("gRshD");
var $1c299a236aa9474b$exports = {};
"use strict";
Object.defineProperty($1c299a236aa9474b$exports, "__esModule", {
    value: true
});

var $g8iUW = parcelRequire("g8iUW");

$g8iUW.__exportStar((parcelRequire("41VLu")), $1c299a236aa9474b$exports);

$g8iUW.__exportStar((parcelRequire("fHi4g")), $1c299a236aa9474b$exports);



var $dDNcL = parcelRequire("dDNcL");

var $gRshD = parcelRequire("gRshD");

var $1MFjU = parcelRequire("1MFjU");


var $dDNcL = parcelRequire("dDNcL");

var $1MFjU = parcelRequire("1MFjU");

var $1MFjU = parcelRequire("1MFjU");
class $5c3171cb4df06a17$export$c7e91f8aec23ae14 {
    constructor(){
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Promise((resolve, reject)=>{
                this.resolve = resolve;
                this.reject = reject;
            })
        });
    }
}
function $5c3171cb4df06a17$export$b06b4c21253e26e2(observable) {
    var _a;
    for (const key of Object.getOwnPropertySymbols(observable)){
        const store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
        if (store instanceof Map) return Object.fromEntries(Array.from(store, ([key, { value_: value_ }])=>[
                key,
                value_
            ]));
    }
}
const $5c3171cb4df06a17$export$4077c0dfbe9c3861 = (root, targetSelector)=>new Promise((resolve)=>{
        const ended = (0, $1MFjU.delegate)(targetSelector, (event)=>{
            root.removeEventListener("animationend", ended);
            root.removeEventListener("animationcancel", ended);
            resolve(event);
        });
        root.addEventListener("animationend", ended);
        root.addEventListener("animationcancel", ended);
    });


var $ac1bb81b2e4cfde8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
function $ac1bb81b2e4cfde8$var$wrapFunction(func) {
    return (props)=>{
        const tree = func(props), renderer = new (0, $1c299a236aa9474b$exports.DOMRenderer)();
        const disposer = (0, $dDNcL.autorun)(()=>{
            const newTree = func(props);
            if (tree.node) Object.assign(tree, renderer.patch(tree, newTree));
        });
        const { ref: ref } = tree;
        tree.ref = (node)=>{
            if (node) tree.node = node;
            else disposer();
            ref === null || ref === void 0 || ref(node);
        };
        return tree;
    };
}
const $ac1bb81b2e4cfde8$var$reactionMap = new WeakMap();
function $ac1bb81b2e4cfde8$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    class ObserverComponent extends Component {
        get props() {
            return (0, $5c3171cb4df06a17$export$b06b4c21253e26e2)(this);
        }
        constructor(){
            super();
            _ObserverComponent_instances.add(this);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            const { update: update } = Object.getPrototypeOf(this);
            this["update"] = ()=>this.disposers.push((0, $dDNcL.autorun)(()=>update.call(this)));
            Promise.resolve().then(()=>$ac1bb81b2e4cfde8$var$__classPrivateFieldGet(this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call(this));
        }
        disconnectedCallback() {
            var _a;
            for (const disposer of this.disposers)disposer();
            this.disposers.length = 0;
            (_a = super["disconnectedCallback"]) === null || _a === void 0 || _a.call(this);
        }
        setAttribute(name, value) {
            const old = super.getAttribute(name), names = this.constructor["observedAttributes"];
            super.setAttribute(name, value);
            if (names.includes(name)) this.attributeChangedCallback(name, old, value);
        }
        attributeChangedCallback(name, old, value) {
            var _a;
            this[(0, $1MFjU.toCamelCase)(name)] = (0, $1MFjU.parseJSON)(value);
            (_a = super["attributeChangedCallback"]) === null || _a === void 0 || _a.call(this, name, old, value);
        }
        syncPropAttr(name) {
            var _a;
            var value = this[(0, $1MFjU.toCamelCase)(name)];
            if (!(value != null) || value === false) return this.removeAttribute(name);
            value = value === true ? name : value;
            if (typeof value === "object") {
                value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                value = typeof value === "object" ? JSON.stringify(value) : value;
            }
            super.setAttribute(name, value);
        }
    }
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        const names = this.constructor["observedAttributes"] || [], reactions = $ac1bb81b2e4cfde8$var$reactionMap.get(this) || [];
        this.disposers.push(...names.map((name)=>(0, $dDNcL.autorun)(()=>this.syncPropAttr(name))), ...reactions.map(({ expression: expression, effect: effect })=>(0, $dDNcL.reaction)((reaction)=>expression(this, reaction), effect.bind(this))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $ac1bb81b2e4cfde8$export$b6ae1bc530f4c149(func, _) {
    return (0, $1MFjU.isHTMLElementClass)(func) ? $ac1bb81b2e4cfde8$var$wrapClass(func) : $ac1bb81b2e4cfde8$var$wrapFunction(func);
}
function $ac1bb81b2e4cfde8$export$af4b9a83f4b00434(_, { name: name, addInitializer: addInitializer }) {
    addInitializer(function() {
        const names = this.constructor["observedAttributes"], attribute = (0, $1MFjU.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
function $ac1bb81b2e4cfde8$export$7203b476385689ae(expression) {
    return (effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $ac1bb81b2e4cfde8$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $ac1bb81b2e4cfde8$var$reactionMap.set(this, reactions);
        });
}




var $gRshD = parcelRequire("gRshD");


var $1MFjU = parcelRequire("1MFjU");
const $5b23a8c63735f5b2$var$eventMap = new WeakMap();
function $5b23a8c63735f5b2$export$d8556a2a8f973135(meta) {
    return (Class, { addInitializer: addInitializer })=>{
        class RendererComponent extends Class {
            get root() {
                return this.internals.shadowRoot || this;
            }
            constructor(){
                super();
                Object.defineProperty(this, "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.attachInternals()
                });
                Object.defineProperty(this, "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $1c299a236aa9474b$exports.DOMRenderer)()
                });
                Object.defineProperty(this, "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !this.internals.shadowRoot) this.attachShadow(meta);
            }
            connectedCallback() {
                var _a, _b;
                const { mode: mode } = meta;
                const renderChildren = !(mode != null);
                const { root: root } = this, events = $5b23a8c63735f5b2$var$eventMap.get(this) || [];
                for (const { type: type, selector: selector, handler: handler } of events){
                    if (renderChildren && /^:host/.test(selector)) console.warn(`[WebCell] DOM Event delegation of "${selector}" won't work if you don't invoke "this.attachShadow()" manually.`);
                    root.addEventListener(type, handler);
                }
                (_a = super["connectedCallback"]) === null || _a === void 0 || _a.call(this);
                if (this.mounted) return;
                this.update();
                this.mounted = true;
                (_b = this.mountedCallback) === null || _b === void 0 || _b.call(this);
            }
            update() {
                var _a, _b;
                const vNode = (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this);
                const content = (0, $1MFjU.isEmpty)(vNode) ? meta.mode ? (0, $gRshD.jsx)("slot", {}) : null : vNode;
                if (content != null) {
                    this.renderer.render(content, this.root);
                    (_b = this.updatedCallback) === null || _b === void 0 || _b.call(this);
                }
            }
            disconnectedCallback() {
                var _a;
                const { root: root } = this, events = $5b23a8c63735f5b2$var$eventMap.get(this) || [];
                for (const { type: type, handler: handler } of events)root.removeEventListener(type, handler);
                (_a = super["disconnectedCallback"]) === null || _a === void 0 || _a.call(this);
            }
            emit(event, detail, { cancelable: cancelable, bubbles: bubbles, composed: composed } = {}) {
                return this.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    cancelable: cancelable,
                    bubbles: bubbles,
                    composed: composed
                }));
            }
            toString() {
                return (0, $1MFjU.stringifyDOM)(this.root);
            }
        }
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $5b23a8c63735f5b2$export$af631764ddc44097(type, selector) {
    return (method, { addInitializer: addInitializer })=>addInitializer(function() {
            const events = $5b23a8c63735f5b2$var$eventMap.get(this) || [], handler = (0, $1MFjU.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $5b23a8c63735f5b2$var$eventMap.set(this, events);
        });
}



var $dDNcL = parcelRequire("dDNcL");

var $f140699978dad43a$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f140699978dad43a$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f140699978dad43a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f140699978dad43a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $f140699978dad43a$export$2a668e8d088a0667(Class, _) {
    let FormFieldComponent = (()=>{
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        let _classSuper = Class;
        let _instanceExtraInitializers = [];
        let _setValue_decorators;
        let _name_decorators;
        let _name_initializers = [];
        let _value_decorators;
        let _value_initializers = [];
        let _required_decorators;
        let _required_initializers = [];
        let _disabled_decorators;
        let _disabled_initializers = [];
        let _autofocus_decorators;
        let _autofocus_initializers = [];
        return _a = class FormFieldComponent extends _classSuper {
            constructor(){
                super(...arguments);
                _FormFieldComponent_name_accessor_storage.set(this, ($f140699978dad43a$var$__runInitializers(this, _instanceExtraInitializers), $f140699978dad43a$var$__runInitializers(this, _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set(this, $f140699978dad43a$var$__runInitializers(this, _value_initializers, void 0));
                _FormFieldComponent_required_accessor_storage.set(this, $f140699978dad43a$var$__runInitializers(this, _required_initializers, void 0));
                _FormFieldComponent_disabled_accessor_storage.set(this, $f140699978dad43a$var$__runInitializers(this, _disabled_initializers, void 0));
                _FormFieldComponent_autofocus_accessor_storage.set(this, $f140699978dad43a$var$__runInitializers(this, _autofocus_initializers, void 0));
            }
            setValue(value) {
                this.internals.setFormValue(value);
            }
            formDisabledCallback(disabled) {
                this.disabled = disabled;
            }
            get name() {
                return $f140699978dad43a$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
            }
            set name(value) {
                $f140699978dad43a$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
            }
            get value() {
                return $f140699978dad43a$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
            }
            set value(value) {
                $f140699978dad43a$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
            }
            get required() {
                return $f140699978dad43a$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
            }
            set required(value) {
                $f140699978dad43a$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
            }
            get disabled() {
                return $f140699978dad43a$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
            }
            set disabled(value) {
                $f140699978dad43a$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
            }
            get autofocus() {
                return $f140699978dad43a$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
            }
            set autofocus(value) {
                $f140699978dad43a$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
            }
            set defaultValue(raw) {
                var _b;
                this.setAttribute("value", raw);
                (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
            }
            get defaultValue() {
                return this.getAttribute("value");
            }
            get form() {
                return this.internals.form;
            }
            get validity() {
                return this.internals.validity;
            }
            get validationMessage() {
                return this.internals.validationMessage;
            }
            get willValidate() {
                return this.internals.willValidate;
            }
            checkValidity() {
                return this.internals.checkValidity();
            }
            reportValidity() {
                return this.internals.reportValidity();
            }
        }, _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                (0, $ac1bb81b2e4cfde8$export$7203b476385689ae)(({ value: value })=>value)
            ];
            _name_decorators = [
                (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
                (0, $dDNcL.observable)
            ];
            _value_decorators = [
                (0, $dDNcL.observable)
            ];
            _required_decorators = [
                (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
                (0, $dDNcL.observable)
            ];
            _disabled_decorators = [
                (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
                (0, $dDNcL.observable)
            ];
            _autofocus_decorators = [
                (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
                (0, $dDNcL.observable)
            ];
            $f140699978dad43a$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"setValue" in obj,
                    get: (obj)=>obj.setValue
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $f140699978dad43a$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"name" in obj,
                    get: (obj)=>obj.name,
                    set: (obj, value)=>{
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _instanceExtraInitializers);
            $f140699978dad43a$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"value" in obj,
                    get: (obj)=>obj.value,
                    set: (obj, value)=>{
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _instanceExtraInitializers);
            $f140699978dad43a$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"required" in obj,
                    get: (obj)=>obj.required,
                    set: (obj, value)=>{
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _instanceExtraInitializers);
            $f140699978dad43a$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"disabled" in obj,
                    get: (obj)=>obj.disabled,
                    set: (obj, value)=>{
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _instanceExtraInitializers);
            $f140699978dad43a$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"autofocus" in obj,
                    get: (obj)=>obj.autofocus,
                    set: (obj, value)=>{
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    })();
    return FormFieldComponent;
}



var $gRshD = parcelRequire("gRshD");

var $dDNcL = parcelRequire("dDNcL");


var $f933257a7f9ea2f4$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f933257a7f9ea2f4$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f933257a7f9ea2f4$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $f933257a7f9ea2f4$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f933257a7f9ea2f4$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f933257a7f9ea2f4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $f933257a7f9ea2f4$export$854a54a999c89982 = (()=>{
    var _AsyncCell_component_accessor_storage, _AsyncCell_delegatedProps_accessor_storage;
    let _classDecorators = [
        (0, $5b23a8c63735f5b2$export$d8556a2a8f973135)({
            tagName: "async-cell"
        }),
        (0, $ac1bb81b2e4cfde8$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _component_decorators;
    let _component_initializers = [];
    let _delegatedProps_decorators;
    let _delegatedProps_initializers = [];
    var AsyncCell = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "loader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($f933257a7f9ea2f4$var$__runInitializers(this, _instanceExtraInitializers), void 0)
            });
            _AsyncCell_component_accessor_storage.set(this, $f933257a7f9ea2f4$var$__runInitializers(this, _component_initializers, void 0));
            _AsyncCell_delegatedProps_accessor_storage.set(this, $f933257a7f9ea2f4$var$__runInitializers(this, _delegatedProps_initializers, void 0));
        }
        get component() {
            return $f933257a7f9ea2f4$var$__classPrivateFieldGet(this, _AsyncCell_component_accessor_storage, "f");
        }
        set component(value) {
            $f933257a7f9ea2f4$var$__classPrivateFieldSet(this, _AsyncCell_component_accessor_storage, value, "f");
        }
        get delegatedProps() {
            return $f933257a7f9ea2f4$var$__classPrivateFieldGet(this, _AsyncCell_delegatedProps_accessor_storage, "f");
        }
        set delegatedProps(value) {
            $f933257a7f9ea2f4$var$__classPrivateFieldSet(this, _AsyncCell_delegatedProps_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.load();
        }
        async load() {
            this.component = undefined;
            const Tag = await this.loader();
            this.component = (_a)=>{
                var { children: children } = _a, props = $f933257a7f9ea2f4$var$__rest(_a, [
                    "children"
                ]);
                return (0, $gRshD.jsx)(Tag, Object.assign({}, props, {
                    children: children
                }));
            };
            this.emit("load", this.component);
        }
        render() {
            const { component: Tag, props: props, delegatedProps: delegatedProps } = this;
            const _a = Object.assign(Object.assign({}, props), delegatedProps), { children: children } = _a, data = $f933257a7f9ea2f4$var$__rest(_a, [
                "children"
            ]);
            return Tag && (0, $gRshD.jsx)(Tag, Object.assign({}, data, {
                children: children
            }));
        }
    };
    _AsyncCell_component_accessor_storage = new WeakMap();
    _AsyncCell_delegatedProps_accessor_storage = new WeakMap();
    $f933257a7f9ea2f4$var$__setFunctionName(_classThis, "AsyncCell");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $dDNcL.observable)
        ];
        _delegatedProps_decorators = [
            (0, $dDNcL.observable)
        ];
        $f933257a7f9ea2f4$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: (obj)=>"component" in obj,
                get: (obj)=>obj.component,
                set: (obj, value)=>{
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _instanceExtraInitializers);
        $f933257a7f9ea2f4$var$__esDecorate(_classThis, null, _delegatedProps_decorators, {
            kind: "accessor",
            name: "delegatedProps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"delegatedProps" in obj,
                get: (obj)=>obj.delegatedProps,
                set: (obj, value)=>{
                    obj.delegatedProps = value;
                }
            },
            metadata: _metadata
        }, _delegatedProps_initializers, _instanceExtraInitializers);
        $f933257a7f9ea2f4$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AsyncCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $f933257a7f9ea2f4$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AsyncCell = _classThis;
})();
function $f933257a7f9ea2f4$export$488013bae63b21da(loader) {
    return (props)=>(0, $gRshD.jsx)($f933257a7f9ea2f4$export$854a54a999c89982, {
            delegatedProps: props,
            loader: async ()=>(await loader()).default
        });
}



var $gRshD = parcelRequire("gRshD");

var $dDNcL = parcelRequire("dDNcL");

var $1MFjU = parcelRequire("1MFjU");





var $21cb5ccb7d4facc0$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $21cb5ccb7d4facc0$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $21cb5ccb7d4facc0$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $21cb5ccb7d4facc0$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $21cb5ccb7d4facc0$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $21cb5ccb7d4facc0$export$2e9a7bb10257a509 = (()=>{
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    let _classDecorators = [
        (0, $5b23a8c63735f5b2$export$d8556a2a8f973135)({
            tagName: "animation-css"
        }),
        (0, $ac1bb81b2e4cfde8$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _playing_decorators;
    let _playing_initializers = [];
    let _typeChanged_decorators;
    var AnimateCSS = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _AnimateCSS_type_accessor_storage.set(this, ($21cb5ccb7d4facc0$var$__runInitializers(this, _instanceExtraInitializers), $21cb5ccb7d4facc0$var$__runInitializers(this, _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set(this, $21cb5ccb7d4facc0$var$__runInitializers(this, _playing_initializers, false));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        get type() {
            return $21cb5ccb7d4facc0$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
        }
        set type(value) {
            $21cb5ccb7d4facc0$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
        }
        get playing() {
            return $21cb5ccb7d4facc0$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
        }
        set playing(value) {
            $21cb5ccb7d4facc0$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
        }
        async connectedCallback() {
            await (0, $1MFjU.importCSS)("https://unpkg.com/animate.css@4/animate.min.css");
            this.typeChanged();
        }
        async typeChanged() {
            this.playing = true;
            await (0, $5c3171cb4df06a17$export$4077c0dfbe9c3861)(this, ".animate__animated");
            this.playing = false;
        }
        render() {
            const { type: type, playing: playing, component: Tag } = this;
            return playing ? (0, $gRshD.jsx)(Tag, {
                className: `animate__animated animate__${type}`
            }) : type.includes("Out") ? (0, $gRshD.jsx)((0, $gRshD.Fragment), {}) : (0, $gRshD.jsx)(Tag, {});
        }
    };
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $21cb5ccb7d4facc0$var$__setFunctionName(_classThis, "AnimateCSS");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
            (0, $dDNcL.observable)
        ];
        _playing_decorators = [
            (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
            (0, $dDNcL.observable)
        ];
        _typeChanged_decorators = [
            (0, $ac1bb81b2e4cfde8$export$7203b476385689ae)(({ type: type })=>type)
        ];
        $21cb5ccb7d4facc0$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _instanceExtraInitializers);
        $21cb5ccb7d4facc0$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"playing" in obj,
                get: (obj)=>obj.playing,
                set: (obj, value)=>{
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _instanceExtraInitializers);
        $21cb5ccb7d4facc0$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: (obj)=>"typeChanged" in obj,
                get: (obj)=>obj.typeChanged
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $21cb5ccb7d4facc0$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $21cb5ccb7d4facc0$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
})();





var $gRshD = parcelRequire("gRshD");

var $dDNcL = parcelRequire("dDNcL");

var $1MFjU = parcelRequire("1MFjU");

var $7070c445c90492b4$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7070c445c90492b4$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7070c445c90492b4$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7070c445c90492b4$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7070c445c90492b4$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $7070c445c90492b4$var$ClockModel = (()=>{
    var _a, _ClockModel_time_accessor_storage;
    let _instanceExtraInitializers = [];
    let _time_decorators;
    let _time_initializers = [];
    return _a = class ClockModel {
        get time() {
            return $7070c445c90492b4$var$__classPrivateFieldGet(this, _ClockModel_time_accessor_storage, "f");
        }
        set time(value) {
            $7070c445c90492b4$var$__classPrivateFieldSet(this, _ClockModel_time_accessor_storage, value, "f");
        }
        constructor(){
            _ClockModel_time_accessor_storage.set(this, ($7070c445c90492b4$var$__runInitializers(this, _instanceExtraInitializers), $7070c445c90492b4$var$__runInitializers(this, _time_initializers, new Date())));
            setInterval(()=>this.time = new Date(), (0, $1MFjU.Second));
        }
    }, _ClockModel_time_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _time_decorators = [
            (0, $dDNcL.observable)
        ];
        $7070c445c90492b4$var$__esDecorate(_a, null, _time_decorators, {
            kind: "accessor",
            name: "time",
            static: false,
            private: false,
            access: {
                has: (obj)=>"time" in obj,
                get: (obj)=>obj.time,
                set: (obj, value)=>{
                    obj.time = value;
                }
            },
            metadata: _metadata
        }, _time_initializers, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $7070c445c90492b4$var$clockStore = new $7070c445c90492b4$var$ClockModel();
const $7070c445c90492b4$export$d9c4eb2a808f1f00 = (0, $ac1bb81b2e4cfde8$export$b6ae1bc530f4c149)(()=>{
    const { time: time } = $7070c445c90492b4$var$clockStore;
    return (0, $gRshD.jsxs)("time", {
        dateTime: time.toJSON(),
        children: [
            "Function Clock: ",
            time.toLocaleString()
        ]
    });
});
let $7070c445c90492b4$export$b7c25167f332ddf2 = (()=>{
    var _ClassClock_time_accessor_storage;
    let _classDecorators = [
        (0, $5b23a8c63735f5b2$export$d8556a2a8f973135)({
            tagName: "class-clock",
            mode: "open"
        }),
        (0, $ac1bb81b2e4cfde8$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _time_decorators;
    let _time_initializers = [];
    let _handleReaction_decorators;
    let _handleClick_decorators;
    var ClassClock = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _ClassClock_time_accessor_storage.set(this, ($7070c445c90492b4$var$__runInitializers(this, _instanceExtraInitializers), $7070c445c90492b4$var$__runInitializers(this, _time_initializers, new Date())));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        get time() {
            return $7070c445c90492b4$var$__classPrivateFieldGet(this, _ClassClock_time_accessor_storage, "f");
        }
        set time(value) {
            $7070c445c90492b4$var$__classPrivateFieldSet(this, _ClassClock_time_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.timer = setInterval(()=>this.time = new Date(), (0, $1MFjU.Second));
        }
        disconnectedCallback() {
            clearInterval(this.timer);
        }
        handleReaction(newValue, oldValue, reaction) {
            console.log(newValue, oldValue, reaction);
        }
        handleClick(event, currentTarget) {
            console.log(event, currentTarget);
        }
        render() {
            const { time: time } = this;
            return (0, $gRshD.jsxs)("time", {
                dateTime: time.toJSON(),
                children: [
                    "Class Clock: ",
                    time.toLocaleString()
                ]
            });
        }
    };
    _ClassClock_time_accessor_storage = new WeakMap();
    $7070c445c90492b4$var$__setFunctionName(_classThis, "ClassClock");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _time_decorators = [
            (0, $ac1bb81b2e4cfde8$export$af4b9a83f4b00434),
            (0, $dDNcL.observable)
        ];
        _handleReaction_decorators = [
            (0, $ac1bb81b2e4cfde8$export$7203b476385689ae)(({ time: time })=>time)
        ];
        _handleClick_decorators = [
            (0, $5b23a8c63735f5b2$export$af631764ddc44097)("click", "time")
        ];
        $7070c445c90492b4$var$__esDecorate(_classThis, null, _time_decorators, {
            kind: "accessor",
            name: "time",
            static: false,
            private: false,
            access: {
                has: (obj)=>"time" in obj,
                get: (obj)=>obj.time,
                set: (obj, value)=>{
                    obj.time = value;
                }
            },
            metadata: _metadata
        }, _time_initializers, _instanceExtraInitializers);
        $7070c445c90492b4$var$__esDecorate(_classThis, null, _handleReaction_decorators, {
            kind: "method",
            name: "handleReaction",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleReaction" in obj,
                get: (obj)=>obj.handleReaction
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7070c445c90492b4$var$__esDecorate(_classThis, null, _handleClick_decorators, {
            kind: "method",
            name: "handleClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleClick" in obj,
                get: (obj)=>obj.handleClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7070c445c90492b4$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ClassClock = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $7070c445c90492b4$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ClassClock = _classThis;
})();



var $gRshD = parcelRequire("gRshD");

var $8ce465f88715a531$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8ce465f88715a531$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8ce465f88715a531$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $8ce465f88715a531$export$d6a4f7c3427f25a9 = (()=>{
    let _classDecorators = [
        (0, $5b23a8c63735f5b2$export$d8556a2a8f973135)({
            tagName: "test-field",
            mode: "open"
        }),
        (0, $f140699978dad43a$export$2a668e8d088a0667),
        (0, $ac1bb81b2e4cfde8$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var TestField = _classThis = class extends _classSuper {
        render() {
            const { name: name } = this;
            return (0, $gRshD.jsx)("input", {
                name: name,
                // @ts-ignore
                onChange: ({ currentTarget: { value: value } })=>this.value = value
            });
        }
    };
    $8ce465f88715a531$var$__setFunctionName(_classThis, "TestField");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $8ce465f88715a531$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TestField = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $8ce465f88715a531$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TestField = _classThis;
})();



const $5d28237666660cec$var$Async = (0, $f933257a7f9ea2f4$export$488013bae63b21da)(()=>(parcelRequire("FLqxQ")));
const $5d28237666660cec$var$Hello = ({ className: className, children: children })=>(0, $gRshD.jsxs)("h1", {
        className: className,
        children: [
            "Hello ",
            children,
            "!"
        ]
    });
const $5d28237666660cec$export$36d69433c4f81145 = ()=>(0, $gRshD.jsxs)((0, $gRshD.Fragment), {
        children: [
            (0, $gRshD.jsx)((0, $21cb5ccb7d4facc0$export$2e9a7bb10257a509), {
                type: "fadeIn",
                component: (props)=>(0, $gRshD.jsx)($5d28237666660cec$var$Hello, Object.assign({}, props, {
                        children: "WebCell"
                    }))
            }),
            (0, $gRshD.jsxs)("div", {
                children: [
                    "We use the same configuration as Parcel to bundle this sandbox, you can find more info about Parcel",
                    (0, $gRshD.jsx)("a", {
                        href: "https://parceljs.org",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "here"
                    }),
                    "."
                ]
            }),
            (0, $gRshD.jsxs)("ul", {
                children: [
                    (0, $gRshD.jsx)("li", {
                        children: (0, $gRshD.jsx)((0, $7070c445c90492b4$export$d9c4eb2a808f1f00), {})
                    }),
                    (0, $gRshD.jsx)("li", {
                        children: (0, $gRshD.jsx)((0, $7070c445c90492b4$export$b7c25167f332ddf2), {})
                    })
                ]
            }),
            (0, $gRshD.jsxs)("form", {
                // @ts-ignore
                onSubmit: ({ currentTarget: currentTarget })=>alert(JSON.stringify((0, $1MFjU.formToJSON)(currentTarget))),
                children: [
                    (0, $gRshD.jsx)((0, $8ce465f88715a531$export$d6a4f7c3427f25a9), {
                        name: "test"
                    }),
                    (0, $gRshD.jsx)("button", {
                        children: "\u221A"
                    })
                ]
            }),
            (0, $gRshD.jsx)($5d28237666660cec$var$Async, {
                children: "content"
            })
        ]
    });


(0, $dDNcL.configure)({
    enforceActions: "never"
});
new (0, $1c299a236aa9474b$exports.DOMRenderer)().render((0, $gRshD.jsx)((0, $5d28237666660cec$export$36d69433c4f81145), {}), document.querySelector("#app"));


//# sourceMappingURL=index.1a661bd6.js.map
